"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var projectsList_1 = require("common/global/projectsList");
var usersList_1 = require("common/global/usersList");
var app_1 = require("firebase/app");
var moment_1 = __importDefault(require("moment"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var useTitle_1 = __importDefault(require("../../hooks/useTitle"));
var NUMBER_OF_APPROVALS = 50;
function WarehousePendingMyApproval() {
    var _this = this;
    var _a = (0, react_1.useState)(false), filter = _a[0], setFilter = _a[1];
    var startOfToday = (0, moment_1.default)();
    var endOfToday = (0, moment_1.default)();
    var _b = (0, react_1.useState)(startOfToday.startOf('month')), startDate = _b[0], setStartDate = _b[1];
    var _c = (0, react_1.useState)(endOfToday.endOf('month')), endDate = _c[0], setEndDate = _c[1];
    var uid = (0, app_1.auth)().currentUser.uid;
    var _d = (0, react_1.useState)(''), formNO = _d[0], setFormNO = _d[1];
    var userSnapshot = (0, firestore_1.useCollection)(collectionsRef_1.usersRef)[0];
    var _e = (0, firestore_1.useCollection)(collectionsRef_1.notificationsRef
        .where('userId', '==', uid)
        .where('action', 'in', ['warehouse', 'GIOApproved', 'SRApproved', "DNApproved"])
        .where('createdAt', '>=', startDate.toDate())
        .where('createdAt', '<=', endDate.toDate())
        .orderBy('createdAt', 'desc')), NotificationSN = _e[0], loadingNotifications = _e[1];
    var t = (0, react_i18next_1.useTranslation)().t;
    (0, useTitle_1.default)(t('common.notifications'));
    if (!userSnapshot || loadingNotifications) {
        return (0, jsx_runtime_1.jsx)(antd_1.Spin, {});
    }
    var dataSource = NotificationSN === null || NotificationSN === void 0 ? void 0 : NotificationSN.docs.filter(function (item) {
        var doc = item.data();
        return formNO == '' ? true : formNO == doc.content.ref;
    }).filter(function (item) {
        return filter ? (item === null || item === void 0 ? void 0 : item.data().approved) == false : true;
    }).map(function (item, idx) {
        var _a, _b, _c, _d;
        var doc = item.data();
        var userName = (_b = (_a = usersList_1.globalUsersData[doc.byUserId]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
        var projectCode = (_c = projectsList_1.globalProjectsData[doc.projectId]) === null || _c === void 0 ? void 0 : _c.code;
        var url = "/warehouses/".concat(doc.docType == 'Receive-SR' ? doc.toWarehouseId : doc.fromWarehouseId, "/").concat(doc.docType, "/true/").concat(doc.docType == 'GIO' ? doc.GIOId : doc.docType == 'DN' ? doc.DNId : doc.SRId);
        return ((0, jsx_runtime_1.jsx)("div", __assign({ style: { margin: 12, background: '#fff', borderRadius: 12, padding: 12 } }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: url, onClick: function () {
                    collectionsRef_1.notificationsRef.doc(item.id).update({ approved: true });
                } }, { children: (0, jsx_runtime_1.jsx)(antd_1.Comment, { content: (0, jsx_runtime_1.jsx)("div", __assign({ style: { marginTop: 10, color: 'gray' } }, { children: (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("h4", __assign({ style: doc.approved ? { color: '#ccc' } : {} }, { children: [(0, jsx_runtime_1.jsx)("b", __assign({ style: { color: '#5db730' } }, { children: doc.docType })), doc.action == "warehouse" ? " Is Pending Your Approval" : " has been Approved!", (0, jsx_runtime_1.jsx)("br", {}), " Paper Number ".concat((_d = doc.content.ref) !== null && _d !== void 0 ? _d : ''), (0, jsx_runtime_1.jsx)("br", {}), "Project code: ".concat(projectCode), (0, jsx_runtime_1.jsx)("br", {}), " description: ".concat(doc.description), (0, jsx_runtime_1.jsx)("br", {}), "Published By: ", (0, jsx_runtime_1.jsx)("b", __assign({ style: { color: '#ff4d4f' } }, { children: userName }))] })) }) })), datetime: (0, jsx_runtime_1.jsx)("span", __assign({ style: { fontSize: '12px', color: '#ccc', whiteSpace: 'nowrap' } }, { children: (0, jsx_runtime_1.jsx)("span", { children: doc === null || doc === void 0 ? void 0 : doc.createdAt.toDate().toLocaleString() }) })) }) }), item.id) }), idx));
    });
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ style: { backgroundColor: '#f0f2f5' } }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-end',
                    marginRight: 20,
                } }, { children: [(0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: { margin: '1%' }, onClick: function () {
                            setFilter(!filter);
                        } }, { children: filter ? 'Show All' : 'Pending My Approval' })), (0, jsx_runtime_1.jsx)(antd_1.Input, { placeholder: 'Form Number', onChange: function (e) { return setFormNO(e.target.value); }, style: { width: '200px', margin: '1%' } }), (0, jsx_runtime_1.jsxs)("span", __assign({ style: { margin: '1%' } }, { children: [t('warehouse.filterStartDate'), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setStartDate(e.startOf('day')); }, value: startDate })] })), (0, jsx_runtime_1.jsxs)("span", __assign({ style: { margin: '1%' } }, { children: [" ", t('warehouse.filterEndDate')] })), (0, jsx_runtime_1.jsx)(antd_1.DatePicker, { onChange: function (e) { return setEndDate(e.endOf('day')); }, value: endDate }), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ style: { margin: '1%' }, danger: true, onClick: function () {
                            var _a;
                            (_a = NotificationSN === null || NotificationSN === void 0 ? void 0 : NotificationSN.docs) === null || _a === void 0 ? void 0 : _a.map(function (doc) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    collectionsRef_1.notificationsRef.doc(doc.id).update({
                                        approved: true,
                                    });
                                    return [2 /*return*/];
                                });
                            }); });
                            console.log(NotificationSN === null || NotificationSN === void 0 ? void 0 : NotificationSN.docs.length);
                        } }, { children: "Read All" }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ style: { padding: '5px 0px' } }, { children: dataSource }))] })));
}
exports.default = WarehousePendingMyApproval;
